import React from 'react';
import StatusBadge from './StatusBadge';
import { newIn2026, updatedIn2026 } from '../data/newIn2026';

function StateCard({ state, onClick }) {
  const isNew     = newIn2026.has(state.lawName);
  const isUpdated = !isNew && updatedIn2026.has(state.lawName);

  return (
    <div
      className="bg-slate-50 rounded-lg border border-slate-200 p-5 card-hover cursor-pointer relative"
      onClick={() => onClick(state)}
    >
      {/* New / Updated badge — top-right ribbon */}
      {isNew && (
        <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold bg-emerald-100 text-emerald-700 border border-emerald-200">
          <i className="fas fa-sparkles text-xs"></i> New 2026
        </span>
      )}
      {isUpdated && (
        <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200">
          <i className="fas fa-rotate text-xs"></i> Updated
        </span>
      )}

      <div className={`flex justify-between items-start mb-3 ${isNew || isUpdated ? 'pr-20' : ''}`}>
        <div>
          <h3 className="text-base font-bold text-gray-900 leading-snug">
            {state.state || state.country}
            {state.region && <span className="text-xs text-gray-400 font-normal ml-1.5">({state.region})</span>}
          </h3>
          <p className="text-xs text-gray-400 mt-0.5">{state.category}</p>
        </div>
        <StatusBadge status={state.status} />
      </div>

      <p className="text-sm font-medium text-gray-700 mb-3 leading-snug">{state.lawName}</p>

      <div className="space-y-1.5 text-xs text-gray-500">
        <div className="flex items-center gap-2">
          <i className="fas fa-calendar-alt text-purple-400 w-3.5 text-center"></i>
          <span><strong className="text-gray-600">Effective:</strong> {state.effectiveDate}</span>
        </div>
        <div className="flex items-center gap-2">
          <i className="fas fa-child text-purple-400 w-3.5 text-center"></i>
          <span><strong className="text-gray-600">Age:</strong> {state.ageRange}</span>
        </div>
      </div>

      {state.notes && (
        <div className="mt-3 p-2.5 bg-amber-50 rounded-md text-xs text-amber-800 leading-snug border border-amber-100">
          <i className="fas fa-info-circle mr-1 text-amber-500"></i>
          {state.notes}
        </div>
      )}
    </div>
  );
}

export default StateCard;
